import { Injectable, ɵɵdefineInjectable, ɵɵinject, Inject, NgModule, Directive, TemplateRef, ViewContainerRef, Input, INJECTOR, Injector } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { MsalService, MSAL_CONFIG, MSAL_CONFIG_ANGULAR, MsalModule } from '@azure/msal-angular';
import { BehaviorSubject, from, of } from 'rxjs';
import { __awaiter } from 'tslib';
import { get } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManager } from 'oidc-client';
import { CommonModule } from '@angular/common';
import jwt_decode from 'jwt-decode';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@azure/msal-angular';
import * as ɵngcc3 from '@angular/router';
class HttpUtility {
    constructor(http) {
        this.http = http;
    }
    /**
     * performs http get api call based on http params
     * @param url -
     * @param httpParams -
     * @param showLoader -
     */
    get(url, httpParams = new HttpParams()) {
        const options = { params: httpParams };
        return this.getByOptions(url, options);
    }
    /**
     * performs http get api call based on options
     * @param url -
     * @param options -
     * @param showLoader -
     */
    getByOptions(url, options) {
        if (url) {
            return this.http.get(url, options)
                .pipe(catchError((e) => { throw e; }));
        }
    }
    /**
     * performs http post api call
     * @param url -
     * @param body -
     * @param httpParams -
     * @param showLoader -
     */
    post(url, body, httpParams = new HttpParams()) {
        if (url) {
            const params = { params: httpParams };
            return this.postByOptions(url, body, params);
        }
    }
    /**
     * performs http post api call
     * @param url -
     * @param body -
     * @param httpOptions -
     */
    postByOptions(url, body, options) {
        return this.http.post(url, body, options)
            .pipe(catchError((e) => { throw e; }));
    }
}
HttpUtility.ɵfac = function HttpUtility_Factory(t) { return new (t || HttpUtility)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
HttpUtility.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HttpUtility, factory: HttpUtility.ɵfac });
HttpUtility.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HttpUtility, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

var _a, _b, _c, _d;
class AuthLibConstant {
}
//#region  User Service Constants
AuthLibConstant.userServiceConstants = (_a = class {
    },
    _a.userInformationKey = 'UserInformation',
    _a.featuresKey = 'Features',
    _a.hasAccess = 'hasAccess',
    _a);
//#endregion User Service Constants
//#region  auth Service Constants
AuthLibConstant.authServiceConstants = (_b = class {
    },
    _b.token = 'token',
    _b.isLoggedIn = 'isLoggedIn',
    _b.loginType = 'loginType',
    _b);
//#endregion  auth Service Constants
//#region  page Constants
AuthLibConstant.page = (_c = class {
    },
    _c.loginUrl = 'login',
    _c);
AuthLibConstant.saml = (_d = class {
    },
    _d.authToken = 'auth-token',
    _d.samlJwtToken = 'jwtToken',
    _d);
AuthLibConstant.configurations = 'Configurations';

//#region angular imports
//#endregion angular imports
class LocalStorageUtility {
    //#region public functions
    /**
     * Get Item by Key
     * @param key -
     */
    getItem(key) {
        const item = localStorage.getItem(key);
        let value = null;
        if (item && item.length > 0) {
            value = JSON.parse(item);
        }
        return value;
    }
    /**
     * Add item to local storage.
     * @param key - unique key
     * @param value - value
     */
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    /**
     * remove item from local storage.
     * @param key - unique Key
     */
    removeItem(key) {
        localStorage.removeItem(key);
    }
    /**
     * Clear local storage.
     */
    clearStorage() {
        localStorage.clear();
    }
    /**
     * Item count in local storage.
     */
    itemCount() {
        return localStorage.length;
    }
}
LocalStorageUtility.ɵfac = function LocalStorageUtility_Factory(t) { return new (t || LocalStorageUtility)(); };
LocalStorageUtility.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LocalStorageUtility, factory: LocalStorageUtility.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalStorageUtility, [{
        type: Injectable
    }], null, null); })();

class AuthHttpService {
    constructor(authConfig, httpService) {
        this.authConfig = authConfig;
        this.httpService = httpService;
    }
    /**
     * fetch userInformation
     */
    getUserInformation(header = null) {
        return this.httpService.getByOptions(this.authConfig.userInformationUrl, header);
    }
    /**
     * fetch role related permissions
     */
    getRolePermissions(header = null) {
        return this.httpService.getByOptions(this.authConfig.featuresUrl, header);
    }
    /**
     * get jwt token
     * @param samlToken - saml token
     */
    getJwtToken(samlToken) {
        return this.httpService.post(this.authConfig.samalConfig.tokenFetchUrl, samlToken);
    }
}
AuthHttpService.ɵfac = function AuthHttpService_Factory(t) { return new (t || AuthHttpService)(ɵngcc0.ɵɵinject(AuthLibConstant.configurations), ɵngcc0.ɵɵinject(HttpUtility)); };
AuthHttpService.ɵprov = ɵɵdefineInjectable({ factory: function AuthHttpService_Factory() { return new AuthHttpService(ɵɵinject("Configurations"), ɵɵinject(HttpUtility)); }, token: AuthHttpService, providedIn: "root" });
AuthHttpService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AuthLibConstant.configurations,] }] },
    { type: HttpUtility }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AuthLibConstant.configurations]
            }] }, { type: HttpUtility }]; }, null); })();

class WindowUtility {
    constructor() { }
    /**
     * reload/refresh current browser tab.
     */
    reload() {
        window.location.reload();
    }
}
WindowUtility.ɵfac = function WindowUtility_Factory(t) { return new (t || WindowUtility)(); };
WindowUtility.ɵprov = ɵɵdefineInjectable({ factory: function WindowUtility_Factory() { return new WindowUtility(); }, token: WindowUtility, providedIn: "root" });
WindowUtility.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WindowUtility, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

//#endregion functional/model imports
class UserService {
    constructor(localStorageService, authHttpService, windowService) {
        this.localStorageService = localStorageService;
        this.authHttpService = authHttpService;
        this.windowService = windowService;
        this._isLoggedIn = new BehaviorSubject(false);
        this._token = null;
        this._userInformation = new BehaviorSubject(null);
        this.initialize();
    }
    //#region component events
    //#endregion component events
    /**
     * logged in user information as observable
     */
    get userInformationObs() {
        return this._userInformation.asObservable();
    }
    /**
     * logged in userInformation
     */
    get userInformation() {
        return this._userInformation.getValue();
    }
    /**
     * set activeRoleFeatures
     */
    set activeRoleFeatures(features) {
        this._activeRoleFeatures = features;
        this.localStorageService.setItem(AuthLibConstant.userServiceConstants.featuresKey, features);
    }
    /**
     * set login status
     * @param status -
     */
    set loginStatus(status) {
        this._isLoggedIn.next(status);
        this.localStorageService.setItem(AuthLibConstant.authServiceConstants.isLoggedIn, status);
    }
    /**
     * login status as observable
     */
    get isLoggedInObs() {
        return this._isLoggedIn.asObservable();
    }
    /**
     * login status
     */
    get isLoggedIn() {
        return this._isLoggedIn.getValue();
    }
    /**
     * set login in type.
     */
    set loginType(loginType) {
        this._loginType = loginType;
        this.localStorageService.setItem(AuthLibConstant.authServiceConstants.loginType, loginType);
    }
    /**
     * get login type.
     */
    get loginType() {
        return this._loginType;
    }
    /**
     * Set AAD/Saml token into localstorage
     */
    set token(token) {
        this._token = token;
        this.localStorageService.setItem(AuthLibConstant.authServiceConstants.token, token);
    }
    /**
     * get token
     */
    get token() {
        return this._token;
    }
    /**
     * get active role.
     */
    get activeRole() {
        const userInfo = this._userInformation.getValue();
        if (userInfo) {
            return userInfo.activeRole;
        }
        return null;
    }
    /**
     * set user Information
     */
    set userInfo(userInfo) {
        this._userInformation.next(userInfo);
        this.localStorageService.setItem(AuthLibConstant.userServiceConstants.userInformationKey, userInfo);
    }
    ngOnDestroy() {
        if (this._isLoggedIn) {
            this._isLoggedIn.unsubscribe();
        }
        if (this._userInformation) {
            this._userInformation.unsubscribe();
        }
    }
    /**
     * clear configurations.
     */
    clearConfigurations() {
        this.token = null;
        this.loginStatus = false;
        this.userInfo = null;
        this.activeRoleFeatures = null;
        this.loginType = null;
    }
    /**
     * initialize user information
     */
    initializeUserInformation() {
        return __awaiter(this, void 0, void 0, function* () {
            const header = {
                headers: new HttpHeaders()
                    .set('Authorization', `Bearer ${this.token}`)
                    .set('LoginType', this._loginType)
            };
            yield this.authHttpService.getUserInformation(header)
                .toPromise()
                .then((userInfo) => {
                if (userInfo && userInfo.roles) {
                    userInfo.activeRole = userInfo.roles.find(r => r.isPrimary);
                }
                this.userInfo = userInfo;
                this.setActiveRole(userInfo.activeRole);
            });
        });
    }
    /**
     * set active role
     * @param role -
     */
    setActiveRole(role) {
        return __awaiter(this, void 0, void 0, function* () {
            if (role) {
                const header = {
                    headers: new HttpHeaders()
                        .set('Authorization', `Bearer ${this.token}`)
                        .set('UserName', this.userInformation.userIdentifier)
                        .set('RoleId', this.userInformation.activeRole.id)
                        .set('LoginType', this._loginType)
                };
                yield this.authHttpService.getRolePermissions(header)
                    .toPromise().then((activeRoleFeatures) => {
                    this.userInformation.activeRole = role;
                    this.userInfo = this.userInformation;
                    this.activeRoleFeatures = activeRoleFeatures;
                    this.loginStatus = true;
                });
            }
        });
    }
    /**
     * Initialize all details.
     */
    initialize() {
        this._token = this.localStorageService.getItem(AuthLibConstant.authServiceConstants.token);
        this._isLoggedIn.next(this.localStorageService.getItem(AuthLibConstant.authServiceConstants.isLoggedIn));
        this._userInformation.next(this.localStorageService.getItem(AuthLibConstant.userServiceConstants.userInformationKey));
        this._activeRoleFeatures = this.localStorageService.getItem(AuthLibConstant.userServiceConstants.featuresKey);
        this._loginType = this.localStorageService.getItem(AuthLibConstant.authServiceConstants.loginType);
    }
    /**
     * Check Feature access
     * @param featureKey - feature permission Key
     */
    checkFeatureAccess(featureKey) {
        const feature = this.getFeatureByKey(featureKey);
        return get(feature, AuthLibConstant.userServiceConstants.hasAccess, false);
    }
    //#endregion public functions
    //#region private functions
    /**
     * Get Feature by key.
     * @param key - string
     */
    getFeatureByKey(key) {
        let featurePermission;
        if (this._activeRoleFeatures) {
            featurePermission = this._activeRoleFeatures.find(f => f.key === key);
        }
        return featurePermission;
    }
}
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵngcc0.ɵɵinject(LocalStorageUtility), ɵngcc0.ɵɵinject(AuthHttpService), ɵngcc0.ɵɵinject(WindowUtility)); };
UserService.ɵprov = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(ɵɵinject(LocalStorageUtility), ɵɵinject(AuthHttpService), ɵɵinject(WindowUtility)); }, token: UserService, providedIn: "root" });
UserService.ctorParameters = () => [
    { type: LocalStorageUtility },
    { type: AuthHttpService },
    { type: WindowUtility }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LocalStorageUtility }, { type: AuthHttpService }, { type: WindowUtility }]; }, null); })();

class AadAuthService {
    //#region constructor
    constructor(msal, userService, authConfigModel) {
        this.msal = msal;
        this.userService = userService;
        this.authConfigModel = authConfigModel;
        this.scope = `${this.authConfigModel.aadConfig.config.auth.clientId}/.default`;
    }
    //#endregion constructor
    //#region public functions
    /**
     * Azure login
     */
    login() {
        this.msal.loginRedirect();
    }
    /**
     * Performs handleWindowCallback operations of adal and sets the logged in user
     */
    handleCallback() {
        const request = {
            scopes: [this.scope]
        };
        this.msal.acquireTokenSilent(request).then((tokenResponse) => {
            this.userService.token = tokenResponse.accessToken;
            this.userService.initializeUserInformation();
        });
    }
    /**
     * Performs user logout
     */
    logout() {
        this.msal.clearCacheForScope(this.scope);
        this.msal.logout();
    }
    /** TODO: Refresh Token Implementation
     * Returns azure token, acquires new token if current token is expired
     */
    refreshToken() {
        const request = {
            scopes: [this.scope]
        };
        return from(this.msal.acquireTokenSilent(request))
            .pipe(map((tokenResponse) => {
            this.userService.token = tokenResponse.accessToken;
            this.userService.initializeUserInformation();
            return this.userService.token;
        }), catchError(error => {
            this.login();
            return '';
        }));
    }
}
AadAuthService.ɵfac = function AadAuthService_Factory(t) { return new (t || AadAuthService)(ɵngcc0.ɵɵinject(ɵngcc2.MsalService), ɵngcc0.ɵɵinject(UserService), ɵngcc0.ɵɵinject(AuthLibConstant.configurations)); };
AadAuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AadAuthService, factory: AadAuthService.ɵfac });
AadAuthService.ctorParameters = () => [
    { type: MsalService },
    { type: UserService },
    { type: undefined, decorators: [{ type: Inject, args: [AuthLibConstant.configurations,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AadAuthService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.MsalService }, { type: UserService }, { type: undefined, decorators: [{
                type: Inject,
                args: [AuthLibConstant.configurations]
            }] }]; }, null); })();

class SamlAuthService {
    constructor(activatedRoute, authHttpService, userService, router, authConfigModel) {
        this.activatedRoute = activatedRoute;
        this.authHttpService = authHttpService;
        this.userService = userService;
        this.router = router;
        this.authConfigModel = authConfigModel;
    }
    /**
     * handle callback saml
     */
    handleCallback() {
        if (!this.userService.token) {
            const authParam = this.activatedRoute.snapshot.queryParams[AuthLibConstant.saml.authToken];
            const token = decodeURIComponent(authParam);
            this.authHttpService.getJwtToken({ saml: token }).subscribe(val => {
                this.userService.token = val.jwtToken;
                this.userService.initializeUserInformation();
            });
        }
        else {
            this.router.navigateByUrl(this.authConfigModel.landingUrl);
        }
    }
    /**
     * saml login
     */
    login() {
    }
    /**
     * saml logout
     */
    logout() {
        this.router.navigateByUrl(this.authConfigModel.loginUrl);
    }
    /**
     * saml refresh token
     */
    refreshToken() {
        return of(this.userService.token);
    }
}
SamlAuthService.ɵfac = function SamlAuthService_Factory(t) { return new (t || SamlAuthService)(ɵngcc0.ɵɵinject(ɵngcc3.ActivatedRoute), ɵngcc0.ɵɵinject(AuthHttpService), ɵngcc0.ɵɵinject(UserService), ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(AuthLibConstant.configurations)); };
SamlAuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SamlAuthService, factory: SamlAuthService.ɵfac });
SamlAuthService.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: AuthHttpService },
    { type: UserService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [AuthLibConstant.configurations,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SamlAuthService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.ActivatedRoute }, { type: AuthHttpService }, { type: UserService }, { type: ɵngcc3.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: [AuthLibConstant.configurations]
            }] }]; }, null); })();

class AuthService {
    constructor(userService, authConfigModel) {
        this.userService = userService;
        this.authConfigModel = authConfigModel;
        this.checkUser = (user) => {
            return !!user && !user.expired;
        };
        this.idpSettings = {
            authority: this.authConfigModel.id4Config.authority,
            client_id: this.authConfigModel.id4Config.client_id,
            client_secret: this.authConfigModel.id4Config.client_secret,
            redirect_uri: this.authConfigModel.id4Config.redirect_uri,
            scope: this.authConfigModel.id4Config.scope,
            response_type: this.authConfigModel.id4Config.response_type,
            post_logout_redirect_uri: this.authConfigModel.id4Config.post_logout_redirect_uri,
            automaticSilentRenew: this.authConfigModel.id4Config.automaticSilentRenew,
            silent_redirect_uri: this.authConfigModel.id4Config.silent_redirect_uri
        };
        this.userManager = new UserManager(this.idpSettings);
    }
    /**
     * ID4 login
     */
    login() {
        this.userManager.signinRedirect();
    }
    /**
      * Performs handleWindowCallback operations of adal and sets the logged in user
      */
    handleCallback() {
        this.userManager.signinRedirectCallback()
            .then(Response => {
            this.userService.token = Response.access_token;
            this.userService.initializeUserInformation();
        });
    }
    /**
     * Performs user logout
     */
    logout() {
        this.userManager.signoutRedirect();
    }
    /** TODO: Refresh Token Implementation
     * Returns azure token, acquires new token if current token is expired
     */
    refreshToken() {
        return from(this.userManager.signinSilentCallback())
            .pipe(map((response => {
            this.userService.token = response.access_token;
            this.userService.initializeUserInformation();
            return this.userService.token;
        }), catchError(error => {
            this.login();
            return '';
        })));
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(UserService), ɵngcc0.ɵɵinject(AuthLibConstant.configurations)); };
AuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
AuthService.ctorParameters = () => [
    { type: UserService },
    { type: undefined, decorators: [{ type: Inject, args: [AuthLibConstant.configurations,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: UserService }, { type: undefined, decorators: [{
                type: Inject,
                args: [AuthLibConstant.configurations]
            }] }]; }, null); })();

//#region angular imports
//#endregion angular imports
class AuthLibModule {
    static forRoot(authConfigs) {
        return {
            ngModule: AuthLibModule,
            providers: [
                {
                    provide: AuthLibConstant.configurations,
                    useValue: authConfigs
                },
                {
                    provide: MSAL_CONFIG,
                    useValue: authConfigs.aadConfig.config
                },
                {
                    provide: MSAL_CONFIG_ANGULAR,
                    useValue: authConfigs.aadConfig.angularConfig
                }
            ]
        };
    }
}
AuthLibModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthLibModule });
AuthLibModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthLibModule_Factory(t) { return new (t || AuthLibModule)(); }, providers: [
        HttpUtility,
        AadAuthService,
        SamlAuthService,
        LocalStorageUtility,
        AuthService
    ], imports: [[
            MsalModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthLibModule, { imports: function () { return [MsalModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthLibModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    MsalModule
                ],
                exports: [],
                providers: [
                    HttpUtility,
                    AadAuthService,
                    SamlAuthService,
                    LocalStorageUtility,
                    AuthService
                ]
            }]
    }], null, null); })();

//#region angular imports
//#endregion functional/model imports
class AuthCheckDirective {
    //#endregion input properties
    //#region constructor
    constructor(templateRef, userService, viewContainer) {
        this.templateRef = templateRef;
        this.userService = userService;
        this.viewContainer = viewContainer;
    }
    //#region input properties
    set appAuthCheck(key) {
        if (key && this.userService.checkFeatureAccess(key)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    }
}
AuthCheckDirective.ɵfac = function AuthCheckDirective_Factory(t) { return new (t || AuthCheckDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(UserService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
AuthCheckDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AuthCheckDirective, selectors: [["", "appAuthCheck", ""]], inputs: { appAuthCheck: "appAuthCheck" } });
AuthCheckDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: UserService },
    { type: ViewContainerRef }
];
AuthCheckDirective.propDecorators = {
    appAuthCheck: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthCheckDirective, [{
        type: Directive,
        args: [{
                selector: '[appAuthCheck]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: UserService }, { type: ɵngcc0.ViewContainerRef }]; }, { appAuthCheck: [{
            type: Input
        }] }); })();

//#region angular imports
//#endregion functional/model imports
class AuthDirectivesModule {
}
AuthDirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthDirectivesModule });
AuthDirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthDirectivesModule_Factory(t) { return new (t || AuthDirectivesModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthDirectivesModule, { declarations: function () { return [AuthCheckDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AuthCheckDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthDirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [AuthCheckDirective],
                exports: [AuthCheckDirective],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();

var LoginType;
(function (LoginType) {
    LoginType["AAD"] = "AAD";
    LoginType["SAML"] = "SAML";
    LoginType["ID4"] = "ID4";
})(LoginType || (LoginType = {}));

class AuthenticationService {
    //#region constructor
    // TODO -  revist on localStorage or sessionStorage. And Storage to be visited.
    // TODO -  Do we need to store User related roles in localStorage?.
    constructor(injector, userService) {
        this.injector = injector;
        this.userService = userService;
        if (this.userService.loginType) {
            this.initializeService();
        }
    }
    /**
     * is user logged in
     */
    get isUserLoggedIn() {
        return this.userService.isLoggedIn;
    }
    /**
     * is user logged in observable
     */
    get isUserLoggedInObs() {
        return this.userService.isLoggedInObs;
    }
    /**
     * login
     * @param loginType -
     */
    login(loginType) {
        this.userService.loginType = loginType;
        this.initializeService();
        this.service.login();
    }
    /**
     * logout
     */
    logout() {
        this.userService.clearConfigurations();
        this.service.logout();
    }
    /**
     * handle callback
     */
    handleCallback() {
        this.service.handleCallback();
    }
    /**
     * Returns AAD/Saml token from local storage
     */
    /**
     * Returns azure token
     */
    getToken() {
        try {
            if (this.userService.isLoggedIn) {
                const currentTime = Date.now() / 1000;
                const decoded = jwt_decode(this.userService.token);
                if (decoded && decoded.exp && (decoded.exp < currentTime)) {
                    return this.service.refreshToken();
                }
                else {
                    return of(this.userService.token);
                }
            }
        }
        catch (err) {
            this.service.logout();
        }
        return of('');
    }
    /**
     * service initialization based on login type.
     */
    initializeService() {
        if (this.userService.loginType === LoginType.AAD) {
            this.service = this.injector.get(AadAuthService);
        }
        else if (this.userService.loginType === LoginType.SAML) {
            this.service = this.injector.get(SamlAuthService);
        }
        else if (this.userService.loginType === LoginType.ID4) {
            this.service = this.injector.get(AuthService);
        }
    }
}
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵngcc0.ɵɵinject(Injector), ɵngcc0.ɵɵinject(UserService)); };
AuthenticationService.ɵprov = ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(ɵɵinject(INJECTOR), ɵɵinject(UserService)); }, token: AuthenticationService, providedIn: "root" });
AuthenticationService.ctorParameters = () => [
    { type: Injector, decorators: [{ type: Inject, args: [Injector,] }] },
    { type: UserService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector, decorators: [{
                type: Inject,
                args: [Injector]
            }] }, { type: UserService }]; }, null); })();

//#region model properties
//#endregion model properties

//#region model properties
//#endregion model properties

//#region model properties
//#endregion model properties

//#region functional/model imports
//#endregion model properties

//#region angular imports
//#endregion functional/model imports
class AuthGuard {
    //#region constructor
    constructor(userService, router, authConfigModel) {
        this.userService = userService;
        this.router = router;
        this.authConfigModel = authConfigModel;
    }
    //#endregion constructor
    //#region public functions/events assoaciated with UI elements
    /**
     * CanActivate Auth Guard
     * @param route -
     * @param state -
     */
    canActivate(route, state) {
        const featureKey = route.data.featureKey;
        const routeBackUrl = state.url;
        return this.checkAccess(featureKey, routeBackUrl);
    }
    /**
     * CanActivateChild Auth Guard
     * @param childRoute -
     * @param state -
     */
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
    /**
     * Can Load Auth Guard
     * @param route -
     */
    canLoad(route) {
        const featureKey = route.data.featureKey;
        return this.checkAccess(featureKey);
    }
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * Check Access
     * @param featureKey -string
     * @param routeBackUrl -string
     */
    checkAccess(featureKey, routeBackUrl) {
        if (this.userService.isLoggedIn) {
            if (featureKey && !this.userService.checkFeatureAccess(featureKey)) {
                throw new Error();
            }
            return of(true);
        }
        else {
            this.router.navigateByUrl(this.authConfigModel.loginUrl);
        }
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(UserService), ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(AuthLibConstant.configurations)); };
AuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(UserService), ɵɵinject(Router), ɵɵinject("Configurations")); }, token: AuthGuard, providedIn: "root" });
AuthGuard.ctorParameters = () => [
    { type: UserService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [AuthLibConstant.configurations,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: UserService }, { type: ɵngcc3.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: [AuthLibConstant.configurations]
            }] }]; }, null); })();

//#region angular imports

//#region angular imports
//#endregion functional/model imports
class CanDeactivateGuard {
    //#region public functions/events 
    /**
     * Can Deactivate
     * @param component - component which implements CanComponentDeactivate
     * Note: Components which needs canDeactivate behaviour should implement CanComponentDeactivate interface.
     */
    canDeactivate(component) {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}
CanDeactivateGuard.ɵfac = function CanDeactivateGuard_Factory(t) { return new (t || CanDeactivateGuard)(); };
CanDeactivateGuard.ɵprov = ɵɵdefineInjectable({ factory: function CanDeactivateGuard_Factory() { return new CanDeactivateGuard(); }, token: CanDeactivateGuard, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CanDeactivateGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/*
 * Public API Surface of auth-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthCheckDirective, AuthDirectivesModule, AuthGuard, AuthLibModule, AuthenticationService, CanDeactivateGuard, LoginType, UserService, HttpUtility as ɵa, AadAuthService as ɵb, AuthLibConstant as ɵc, LocalStorageUtility as ɵd, AuthHttpService as ɵe, WindowUtility as ɵg, SamlAuthService as ɵh, AuthService as ɵi };

//# sourceMappingURL=colibrium-auth-lib.js.map